import { Box } from '@mui/material'
import React from 'react'
import { Info } from './Info'
import { Images } from './Images'
import { SnakeLoader } from '../../../../../../../core/loader/SnakeLoader'

export const Desktop = ({ viewdata, cmtznLoader }) => {
	return (
		<Box>
			{
				cmtznLoader.data ?
					<Box pt={30} display="flex" justifyContent="center" alignItems="center" flexDirection="column" my={5} >
						<SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
					</Box>
					:
					<Box width="100%" display="flex" className="overflowY" px={4} pb={8}>
						<Box width="60%" >
							<Info viewdata={viewdata}/>
						</Box>
						<Box width="40%">
							<Images viewdata={viewdata}/>
						</Box>
					</Box>
			}

		</Box>

	)
}
